import { Routes } from '@angular/router';

import { UserType } from '@gymautoc/common/core/enums/user-type';

import { LayoutComponent } from './layouts/layout.component';
import { AuthGuard } from './modules/auth/guards/auth.guard';
import { RestrictUserTypesGuard } from './modules/auth/guards/restrict-user-types.guard';

/** Application routes. */
export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'users',
        loadChildren: () => import('./modules/users/users.routes').then(m => m.routes),
        canActivate: [RestrictUserTypesGuard],
        data: {
          userTypes: [UserType.Admin],
        },
      },
      {
        path: 'studios',
        loadChildren: () => import('./modules/studios/studios.routes').then(m => m.routes),
        canActivate: [RestrictUserTypesGuard],
        data: {
          userTypes: [UserType.StudioManager],
        },
      },
      {
        path: 'classes',
        loadChildren: () => import('./modules/classes/classes.routes').then(m => m.routes),
        canActivate: [RestrictUserTypesGuard],
        data: {
          userTypes: [UserType.StudioManager, UserType.Staff],
        },
      },
      {
        path: 'scheduler',
        loadChildren: () => import('./modules/scheduler/scheduler.routes').then(m => m.routes),
        canActivate: [RestrictUserTypesGuard],
        data: {
          userTypes: [UserType.Admin, UserType.StudioManager, UserType.Staff],
        },
      },
      {
        path: 'instructors',
        loadChildren: () => import('./modules/instructors/instructors.routes').then(m => m.routes),
        canActivate: [RestrictUserTypesGuard],
        data: {
          userTypes: [UserType.StudioManager],
        },
      },
      {
        path: 'registrations',
        loadChildren: () => import('./modules/enrollment-applications/enrollment-applications.routes').then(m => m.routes),
        canActivate: [RestrictUserTypesGuard],
        data: {
          userTypes: [UserType.StudioManager, UserType.Parent],
        },
      },
      {
        path: 'students',
        loadChildren: () => import('./modules/students/students.routes').then(m => m.routes),
        canActivate: [RestrictUserTypesGuard],
        data: {
          userTypes: [UserType.StudioManager, UserType.Staff, UserType.Parent],
        },
      },
      {
        path: 'holidays',
        loadChildren: () => import('./modules/holidays/holidays.routes').then(m => m.routes),
        canActivate: [RestrictUserTypesGuard],
        data: {
          userTypes: [UserType.Admin, UserType.StudioManager],
        },
      },
      {
        path: 'payment-history',
        loadChildren: () => import('./modules/payment-history/payment-history.routes').then(m => m.routes),
        canActivate: [RestrictUserTypesGuard],
        data: {
          userTypes: [UserType.StudioManager],
        },
      },
      {
        path: 'programs',
        loadChildren: () => import('./modules/class-groups/class-group.routes').then(m => m.routes),
        canActivate: [RestrictUserTypesGuard],
        data: {
          userTypes: [UserType.StudioManager],
        },
      },
      {
        path: 'not-found',
        loadComponent: () =>
          import('./modules/shared/components/not-found-page/not-found-page.component').then(m => m.NotFoundPageComponent),
      },
    ],
  },
  {
    path: 'auth',
    loadComponent: () => import('./modules/auth/auth-page.component').then(m => m.AuthPageComponent),
    loadChildren: () => import('./modules/auth/auth.routes').then(m => m.routes),
  },
  { path: '**', redirectTo: 'auth' },
];
